import {
  invalidateLeadBoard,
  invalidateLeadTimeline,
  queryClient,
} from "@/lib/queryClient";

/**
 * Actor-side refresh after niche flows create deals via a direct
 * POST /core/child. The socket echo no longer refreshes the actor's screens,
 * so bust what a new deal changes: list/board + count/stats ("Total
 * Children"), the card deal-hover list and the lead's timeline. The caller
 * still refetches the drawer's lead / deal list / current deal itself.
 */
export function refreshAfterDealCreate(
  leadId: number | string | null | undefined
) {
  invalidateLeadBoard();
  queryClient.invalidateQueries({ queryKey: ["lead-children-hover"] });
  invalidateLeadTimeline(leadId ?? null);
}
